$(document).on("click", ".at_product_button_c", function(){
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $(".form").serialize(),
    beforeSend: function(){
      console.log('before enter');
      $(".at_product_button_c").addClass("loading");
      $(".at_product_button_c").find(".loading-overlay__spinner").removeClass("hidden");
    },
    success:function(rst){
      console.log("success");
      $(".at_product_success").text("Product added to cart successfully");
    },
    error:function(err){
      console.log("error", err);
      $(".at_product_success").text("error");
    },complete:function(cart){
      console.log("complete");
      $(".at_product_button_c").removeClass("loading");
      $(".at_product_button_c").find(".loading-overlay__spinner").addClass("hidden");
      setTimeout(function() { 
        $(".at_product_success").hide();
    }, 3000);
    }
  });
});
